import React from 'react';
import { Box, Typography } from '@mui/material';

function Notifications({ user }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        No notifications
      </Typography>
    </Box>
  );
}

export default Notifications;

